import { useQuery } from '@tanstack/react-query';

import { statsApi } from '@/services/stats.service';
import type { AnalyticsOverview } from '@/types/stats.types';

export const ANALYTICS_QUERY_KEY = 'analytics';

export interface UseAnalyticsPageResult {
  analytics: AnalyticsOverview | undefined;
  isLoading: boolean;
  isError: boolean;
  errorMessage: string | null;
}

export const useAnalyticsPage = (): UseAnalyticsPageResult => {
  const analyticsQuery = useQuery({
    queryKey: [ANALYTICS_QUERY_KEY],
    queryFn: () => statsApi.analytics(),
  });

  return {
    analytics: analyticsQuery.data,
    isLoading: analyticsQuery.isLoading,
    isError: analyticsQuery.isError,
    errorMessage: analyticsQuery.error instanceof Error ? analyticsQuery.error.message : null,
  };
};
